module.exports = __webpack_public_path__ + "img/news3.ee1b64a2.svg";